module.exports = __webpack_public_path__ + "fonts/FuturaStd-Heavy.958258ee.eot";